<script>
import { h, compile } from 'vue';
import { useRouter } from 'vue-router';
import routerUtils from '@/lib/routerUtils';

export default {
  name: 'DynamicComponent',

  props: {
    content: { required: true, type: String }
  },

  emits: ['editPopup'],

  data() {
    return {
      eventHandlers: []
    };
  },

  methods: {
    editItem(key) {
      this.$emit('editPopup', key);
    },
    handleInternalLinkClick(pathname) {
      this.$router.push(pathname);
    },
    attachEventListeners() {
      // Attach event listeners to internal links
      const links = this.$el.querySelectorAll('a:not(.validContext a):not(.placeholder a)');
      links.forEach((link) => {
        const { isInternalLink } = routerUtils.analyzeUrlForNavigation(link.href);
        if (isInternalLink) {
          const url = new URL(link.href);
          // eslint-disable-next-line no-param-reassign
          link.href = url.pathname;
          if (url.pathname) {
            const handler = (event) => {
              event.preventDefault();
              this.handleInternalLinkClick(url.pathname);
            };
            link.addEventListener('click', handler);
            this.eventHandlers.push({ element: link, handler });
          }
        }
      });

      // Attach event listeners to span with class 'placeholder' or 'validContext'
      const placeholders = this.$el.querySelectorAll(
        'span.placeholder[data-key], span.validContext[data-key]'
      );
      placeholders.forEach((placeholder) => {
        const { key } = placeholder.dataset;
        const handler = (event) => {
          event.preventDefault();
          this.editItem(key);
        };
        placeholder.addEventListener('click', handler);
        this.eventHandlers.push({ element: placeholder, handler });
      });
    },
    detachEventListeners() {
      // Detach event listeners from internal links AND divs with class 'placeholder' or 'validContext'
      this.eventHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers = []; // Clear the event handlers array
    }
  },

  render() {
    return h({
      render: compile(`<div class="DynamicContent">${this.content}</div>`, {
        onError: (error) => {
          console.error('Error compiling template:', error);
        },
        onWarn: (warning) => {
          console.warn('Warning during template compilation:', warning);
        }
      })
    });
  },

  mounted() {
    this.$router = useRouter();
    this.$nextTick(() => {
      this.attachEventListeners();
    });
  },

  updated() {
    this.$router = useRouter();
    this.$nextTick(() => {
      this.attachEventListeners();
    });
  },

  beforeUnmount() {
    this.detachEventListeners();
  }
};
</script>
<style scoped>
.underline {
  text-decoration: underline;
}

.DynamicContent :deep(.tooltip) {
  position: relative;
  display: inline-block;
}

.DynamicContent :deep(.tooltip .tooltip-text) {
  margin-left: -100px;
  top: 2rem;
  left: 50%;
  visibility: hidden;
  width: 200px;
  background: rgba(97, 97, 97, 0.9);
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 5px 16px;
  position: absolute;
  z-index: 10;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-transform: none;
  pointer-events: none;
}

.DynamicContent :deep(.tooltip:hover .tooltip-text) {
  visibility: visible;
}
</style>
